var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.progress)?_c('ProgressCircular'):_vm._e(),(!_vm.progress)?_c('v-row',{attrs:{"fluid":""}},[_c('v-col',{attrs:{"cols":"3"}},[_c('NavigationDrawer',{attrs:{"plant":_vm.plant}})],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }